export const esSupport = {
  'support.account': 'Cuenta',
  'support.back': 'Volver a Cuenta',
  'support.billing': 'Facturación',
  'support.category': 'Categoría',
  'support.closeTicket': 'Cerrar ticket',
  'support.create': 'Crear ticket',
  'support.createError': 'No pudimos crear el ticket. Revisa los datos e inténtalo otra vez.',
  'support.description': 'Cada conversación queda privada entre tú y el equipo de soporte.',
  'support.detail': 'Detalle',
  'support.empty': 'Todavía no has creado tickets.',
  'support.feature': 'Funcionalidad',
  'support.financeGoTeam': 'Equipo FinanceGo',
  'support.help': 'Soporte FinanceGo',
  'support.high': 'Alta',
  'support.loadError': 'No pudimos cargar tus tickets.',
  'support.low': 'Baja',
  'support.new': 'Nuevo ticket',
  'support.normal': 'Normal',
  'support.other': 'Otro',
  'support.priority': 'Prioridad',
  'support.reply': 'Responder',
  'support.response': 'Tu respuesta',
  'support.sending': 'Enviando…',
  'support.subject': 'Asunto',
  'support.technical': 'Problema técnico',
  'support.ticketLabel': 'Ticket {id}',
  'support.tickets': 'Tus tickets',
  'support.title': 'Ayuda clara, con seguimiento.',
  'support.urgent': 'Urgente',
  'support.whatNeeded': 'Cuéntanos qué necesitas',
  'support.you': 'Tú',
  'support.statusClosed': 'Cerrado',
  'support.statusInProgress': 'En proceso',
  'support.statusOpen': 'Abierto',
  'support.statusResolved': 'Resuelto',
  'support.statusWaiting': 'Esperando tu respuesta',
} as const;

export const enSupport: Record<keyof typeof esSupport, string> = {
  'support.account': 'Account',
  'support.back': 'Back to Account',
  'support.billing': 'Billing',
  'support.category': 'Category',
  'support.closeTicket': 'Close ticket',
  'support.create': 'Create ticket',
  'support.createError': 'We could not create the ticket. Review the data and try again.',
  'support.description': 'Every conversation stays private between you and the support team.',
  'support.detail': 'Details',
  'support.empty': 'You have not created any tickets yet.',
  'support.feature': 'Feature',
  'support.financeGoTeam': 'FinanceGo team',
  'support.help': 'FinanceGo support',
  'support.high': 'High',
  'support.loadError': 'We could not load your tickets.',
  'support.low': 'Low',
  'support.new': 'New ticket',
  'support.normal': 'Normal',
  'support.other': 'Other',
  'support.priority': 'Priority',
  'support.reply': 'Reply',
  'support.response': 'Your reply',
  'support.sending': 'Sending…',
  'support.subject': 'Subject',
  'support.technical': 'Technical issue',
  'support.ticketLabel': 'Ticket {id}',
  'support.tickets': 'Your tickets',
  'support.title': 'Clear help, with follow-through.',
  'support.urgent': 'Urgent',
  'support.whatNeeded': 'Tell us what you need',
  'support.you': 'You',
  'support.statusClosed': 'Closed',
  'support.statusInProgress': 'In progress',
  'support.statusOpen': 'Open',
  'support.statusResolved': 'Resolved',
  'support.statusWaiting': 'Waiting for your reply',
};
